/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrBoolData } from './genericApiResponseDictStrBoolData';
import type { GenericApiResponseDictStrBoolMessage } from './genericApiResponseDictStrBoolMessage';
import type { GenericApiResponseDictStrBoolPagination } from './genericApiResponseDictStrBoolPagination';
import type { GenericApiResponseDictStrBoolError } from './genericApiResponseDictStrBoolError';

export interface GenericApiResponseDictStrBool {
  data?: GenericApiResponseDictStrBoolData;
  message?: GenericApiResponseDictStrBoolMessage;
  pagination?: GenericApiResponseDictStrBoolPagination;
  error?: GenericApiResponseDictStrBoolError;
  statusCode?: number;
}
